import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { getDecodedToken, LogoutOfSystem } from "@utils/helper/index.helper";
import { useUser } from "@utils/states/index.state";
import Cookies from "js-cookie";
import { Check, ChevronsUpDown } from "lucide-react";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router";

const workspaces = [
  {
    id: 1,
    name: "My Details",
    link: "/profile?type=details",
  },
  {
    id: 2,
    name: "Change Password",
    link: "/profile?type=password",
  },
];

export default function WorkspaceSwitcher({
  username,
  avatar,
  role,
}: {
  username: string | undefined | React.ReactElement;
  avatar: string;
  role: string;
}) {
  const [selectedWorkspace] = useState<{
    id: number;
    name: string;
    link: string;
  }>();
  const decodedToken = getDecodedToken(
    Cookies.get("access") || sessionStorage.getItem("access") || ""
  );
  console.log(decodedToken, "decodedToken");
  const { clear } = useUser();
  const navigate = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center cursor-pointer gap-2 px-4   py-2.5  rounded-lg">
        <Avatar className="rounded-lg h-10 w-10">
          <AvatarImage
            src={avatar || ""}
            alt="Avatar"
            className="rounded-full"
          />
          <AvatarFallback className="bg-[linear-gradient(180deg,_#1DAA7E_0%,_#1A8463_100%)] hover:bg-[linear-gradient(180deg,_#1DAA7E_0%,_#1DAA7E_100%)] text-primary-foreground shadow-xs hover:bg-primary/90">
            A
          </AvatarFallback>
        </Avatar>
        <div className="text-start flex flex-col gap-1 leading-none">
          <span className="text-sm capitalize flex gap-1 leading-none font-semibold truncate max-w-[17ch]">
            {username || "N/A"}
          </span>
          <span className="text-xs text-muted-foreground capitalize truncate max-w-[20ch]">
            {role || "N/A"}
          </span>
        </div>
        <ChevronsUpDown className="ml-6 h-4 w-4 text-muted-foreground" />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-52" align="start">
        <DropdownMenuLabel className="text-[12px]">Actions</DropdownMenuLabel>
        {workspaces.map((workspace) => (
          <Link to={workspace.link}>
            <DropdownMenuItem key={workspace.id} className="cursor-pointer">
              <div className="flex items-center gap-2">
                <div className="flex flex-col">
                  <span>{workspace.name}</span>
                </div>
              </div>
              {selectedWorkspace
                ? selectedWorkspace.id === workspace.id && (
                    <Check className="ml-auto" />
                  )
                : null}
            </DropdownMenuItem>
          </Link>
        ))}
        <DropdownMenuItem
          className="cursor-pointer"
          onClick={() => {
            clear();
            LogoutOfSystem();
            navigate("/login");
          }}
        >
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
